"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = addOutsideClick;
var _enums = require("../constants/enums");
function addListener(event, cb) {
  document.addEventListener(event, cb);
  return function () {
    return document.removeEventListener(event, cb);
  };
}
function addOutsideClick(element, onOutsideClick) {
  function handleClick(event) {
    var isDescendantOfRoot = element.contains(event.target);
    if (!isDescendantOfRoot) {
      onOutsideClick(event);
    }
  }
  function handleKeyDown(event) {
    if (_enums.EventCodes.Escape === event.key) {
      onOutsideClick(event);
    }
  }
  var removeKeyDown = addListener('keydown', handleKeyDown);
  var removeClick = addListener('click', handleClick);
  return function () {
    removeKeyDown();
    removeClick();
  };
}